// extracted by mini-css-extract-plugin
module.exports = {"background":"bj_ff","values":"bj_fq"};